import { Notifications as MantineNotifications } from '@mantine/notifications';

export const Notifications = MantineNotifications.extend({
	defaultProps: {
		variant: 'success',
	},
});
